<template>
  <div class="shop__cart">
    <el-dialog
      :show-close="false"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <h1>确认删除此产品吗？</h1>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteProduct">确 定</el-button>
      </span>
    </el-dialog>
    <div class="dialog__two">
      <el-dialog 
      :show-close="true" 
      :visible.sync="planceOrder"
      width="560px"
      >
        <div class="plance__order">
          <div>扫一扫去下单</div>
          <div>前往微信小程序下单，咨询与售后更加方便 ~</div>
          <img src='https://static.zc0901.com/dci/series/code-2.jpg' />
          <div class="process__list">
            <div class="process__list__item" v-for="(item,index) in processList" :key="index">
              <img :src="item.img" />
              <div>{{item.title}}</div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
    <div class="cart__box">
      <div class="cart__header">
        <div>产品</div>
        <div>单价</div>
        <div>数量</div>
        <div>金额</div>
      </div>
      <div v-if="inventory.length || invalidCart.length || stockMore.length">
        <div class="cart__content">
          <!-- 有效的 -->
          <cartItem
            :type="1"
            @onDeleteFn="onDeleteFn"
            v-for="(item,index) in stockMore"
            :key="index"
            :list="item"
            @changeCartSelect="selectCart"
            @changeNumber="changeNumber"
            @minus="minus"
            @add="add"
            @inputChange="inputChange"
          ></cartItem>
          <!-- 库存不足的 -->
          <cartItem
            :type="1"
            @onDeleteFn="onDeleteFn"
            v-for="item in inventory"
            :key="item.productId"
            :list="item"
            @changeCartSelect="selectCart"
            @changeNumber="changeNumber"
            @minus="minus"
            @add="add"
            @inputChange="inputChange"
          ></cartItem>
          <!-- 失效的 -->
          <cartItem
            :type="2"
            @onDeleteFn="onDeleteFn"
            @seriesSearch="changeSeries"
            v-for="(item) in invalidCart"
            :key="item.id"
            :list="item"
            :seriesList="seriesList"
          ></cartItem>
        </div>
        <div class="cart__foot">
          <div class="cart__foot__left">
            <div class="cart__foot__left_select">
              <div class="cart__foot__left_select_all" @click="selectedAll">
                <img
                  :src="select?'https://static.zc0901.com/imola-dci-product-full.png':'https://static.zc0901.com/dci-web-cart-empty.png'"
                />
                <span class>全选</span>
              </div>
              <span class="cart__foot__left_select_line">|</span>
              <!-- <span class="clearShop" @click="clearShop">清除失效商品</span> -->
              <el-button
                type="text"
                :disabled="invalidCart.length?false:true"
                @click="clearShop"
              >清除失效商品</el-button>
            </div>
            <div class="mt1 text-red text-left prl4">已选{{total.num}}件（{{total.area}}平米）</div>
          </div>
          <div class="cart__foot__right">
            <div class="cart__foot__right__content">
              <div>¥ {{total.totalPrice}}</div>
              <div>{{total.totalPrice>20000?'已满足包邮条件':'未满足包邮条件'}}</div>
            </div>
            <el-button
              type="primary"
              :disabled="cartList.length?false:true"
              class="cart__foot__order"
              @click="confirmOrder"
            >下单</el-button>
          </div>
        </div>
      </div>

      <div class="cart__empty" v-else>
        <img src="https://static.zc0901.com/dci-web-shop-cart-empty.png" />
        <div>购物车里空空如也</div>
      </div>
    </div>
  </div>
</template>
<script>
import "./index.scss";
import cartItem from "../shopCart/cartItem/index";
let msgBox = null;
export default {
  components: {
    cartItem
  },
  data() {
    return {
      dialogVisible: false,
      planceOrder: false,
      cartList: [], //有效的
      invalidCart: [], //无效的
      inventory: [],
      stockMore: [],
      select: false,
      shopItem: {},
      seriesList: [],
      total: {
        num: 0, //总件数
        area: 0, //总面积
        totalPrice: 0 //总金额
      },
      processList: [
        {
          img: "https://static.zc0901.com/dci-web-caet-step-1.png",
          title: "1.扫描二维码"
        },
        {
          img: "https://static.zc0901.com/dci-web-caet-step-2.png",
          title: "2.登录账户"
        },
        {
          img: "https://static.zc0901.com/dci-web-caet-step-3.png",
          title: "3.购物车下单购买"
        }
      ]
    };
  },
  computed: {
    
  },
  created() {
    this.getCartList();
  },
  mounted() {},
  methods: {
    async getCartList() {
      const res = await this.$store.dispatch("shop/CARTLIST");
      if (res.code === 200 && res.data) {
        let invalidList = res.data.off;
        if (invalidList.length) {
          //无效的
          invalidList.forEach(item => {
            item.show = false;
          });
          this.invalidCart = invalidList;
        } else {
          this.invalidCart = [];
        }
        if (res.data.ins.length) {
          //有效的
          let selectLen = res.data.ins.filter(item => item.selected).length;
          if (res.data.ins.length === selectLen) this.select = true;
          this.cartList = res.data.ins; //库存不足或者库存不足的
          let inventory = res.data.ins.filter(item => item.isInventory); //库存不足的
          let stockMore = res.data.ins.filter(item => !item.isInventory); //库存足的
          this.inventory = inventory;
          this.stockMore = stockMore;
        }
        this.count();
      } else if (res.code === 200 && !res.data) {
        this.cartList = [];
        this.invalidCart = [];
      }
    },
    //购物车单个选中状态
    async selectCart(item) {
      let shopList = this.cartList;
      let selectArr = [];
      shopList.forEach(shop => {
        if (shop.id === item.id) {
          shop.selected = !shop.selected;
        }
      });
      if (shopList.length) {
        //有效的总条数是否全选中或者全取消
        selectArr = shopList.filter(item => item.selected).length;
        if (shopList.length === selectArr) this.select = !this.select;
        if (shopList.length !== selectArr) this.select = false;
      }
      this.count();
      let params = {
        productId: item.productId,
        selected: item.selected
      };
      await this.$store.dispatch("shop/CARTCHECK", params);
    },
    //购物车全部选中或者全部取消
    async selectedAll() {
      let shopList = this.cartList;
      this.select = !this.select;
      shopList.forEach(item => {
        item.selected = this.select;
      });
      this.count();
      let params = {
        selected: this.select
      };
      await this.$store.dispatch("shop/CARTCHECKALL", params);
    },
    inputChange(e, list) {
      const onlyNumber = /^[1-9]\d*$/;
      let shopList = this.cartList;
      shopList.forEach(shop => {
        if (shop.id === list.id) {
          shop.number = list.number.replace(/\D/g, "");
        }
      });
    },
    //更改购物车的数量
    async changeNumber(currentValue, list) {
      let shopList = this.cartList;
      shopList.forEach(shop => {
        if (shop.id === list.id) {
          if (currentValue > list.stock) {
            //最大不能超过库存
            shop.number = list.stock;
            if (!msgBox) {
              msgBox = this.$message.info("购买数量超过库存");
              msgBox.onClose = () => {
                msgBox = null;
              };
            }
          } else if (currentValue == 0) {
            //最小数量为1
            shop.number = 1;
            if (!msgBox) {
              msgBox = this.$message.info("最少选中1件哦~");
              msgBox.onClose = () => {
                msgBox = null;
              };
            }
          }
        }
      });
      let params = {
        productId: list.productId,
        number: Number(list.number)
      };
      console.log('更改params',params)
      const res = await this.$store.dispatch("shop/CARTSNUMBER", params);
      if (res.code === 200) {
        this.getCartList();
      }
    },
    //购物车减
    minus(list) {
      let shopList = this.cartList;
      shopList.forEach(async shop => {
        if (shop.id === list.id) { 
          if (shop.number == 1) {
            if (!msgBox) {
              msgBox = this.$message.info("最少选中1件哦~");
              msgBox.onClose = () => {
                msgBox = null;
              };
            }
          } else {
            let params = {
              productId: list.productId,
              number: list.number - 1,
              type:1
            };
            console.log('减少',params)
            const res = await this.$store.dispatch("shop/CARTSNUMBER", params);
            if (res.code === 200) {
              this.getCartList();
            }
          }
        }
      });
    },
    //购物车加
    add(list) {
      let shopList = this.cartList;
      shopList.forEach(async shop => {
        if (shop.id === list.id) {
          if (Number(list.number) >= Number(shop.stock)) {
            if (!msgBox) {
              msgBox = this.$message.info("购买数量超过库存");
              msgBox.onClose = () => {
                msgBox = null;
              };
            }
          } else {
            let params = {
              productId: list.productId,
              number: list.number + 1
            };
            const res = await this.$store.dispatch("shop/CARTSNUMBER", params);
            if (res.code === 200) {
              this.$message.success("添加成功") 
              this.getCartList();
            }
          }
        }
      });
    },
    //计算商品的总件数总平米总价格
    count() {
      let shopList = this.cartList;
      if (!shopList.length) return;
      let selectList = shopList.filter(item => item.selected);
      let num = 0; //件数
      let area = 0; //面积
      let price = 0; //总金额
      if (!selectList.length) {
        this.total.num = 0;
        this.total.area = 0;
        this.total.totalPrice = 0;
        return;
      }
      selectList.forEach(shop => {
        shop.sumPrice = (shop.number * shop.price).toFixed(2);
        num += shop.number;
        area += shop.area * shop.number;
        price += shop.price * shop.number;
      });
      this.total.num = num;
      this.total.area = area.toFixed(2);
      this.total.totalPrice = price.toFixed(2);
    },
    //删除购物车
    onDeleteFn(shop) {
      this.shopItem = shop;
      this.dialogVisible = true;
    },
    handleClose(done) {
      console.log("=====", done);
    },
    // 删除购物车产品
    async deleteProduct() {
      this.dialogVisible = false;
      let res = await this.$store.dispatch("shop/CARTDEL", { id: this.shopItem.id })
      if( res.code === 200 ){
        this.$message.success("删除成功") 
        this.getCartList()
      }
    },
    //失效商品系列查看
    async changeSeries(shop) {
      let list = this.invalidCart;
      list.forEach(item => {
        if (item.id === shop.id) {
          item.show = !item.show;
        } else {
          item.show = false;
        }
      });
      const res = await this.$store.dispatch("series/SERIESLIST");
      if (res.code === 200) {
        this.seriesList = res.data;
      }
    },
    //删除所有失效商品
    async clearShop() {
      await this.$store.dispatch("shop/INVALIDDEL");
      this.getCartList();
    },
    // 下单按钮
    confirmOrder(e) {
      let shopList = this.cartList;
      let selectList = shopList.filter(item => item.selected);
      let stockShortage = shopList.filter(item => item.number > item.stock);
      if (!selectList.length) {
        this.$message.success("请选择商品");
        return;
      }
      if (stockShortage.length) {
        this.$message.info("购物车中含超库存的商品");
        return;
      }
      this.planceOrder = true;
    }
  }
};
</script>
<style lang="scss">
.dialog-footer {
  width: 344px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  .el-button {
    width: 160px;
    height: 52px;
    background: rgba(241, 241, 241, 1);
    border-radius: 4px;
  }
  .el-button:nth-of-type(2) {
    background: rgba(18, 18, 23, 1);
  }
}
.dialog__two {
  .el-dialog {
    height:576px;
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      padding: 0;
    }
  }
}
</style>
